import { SubscriptionPolicy } from '../../domain';
import { ExtendedMessageType, ExtendedChannel } from '../types';
import { aggregateChannelIds } from './aggregateChannelIds';
import { filterByChannelIds } from './filterByChannelIds';

const byPolicy =
  (subPolicies: SubscriptionPolicy[]) =>
  ({ subscriptionPolicy }: ExtendedMessageType) =>
    subPolicies.includes(subscriptionPolicy);

export const filterByPolicy = (
  policies: SubscriptionPolicy[],
  channels: ExtendedChannel[],
  messageTypes: ExtendedMessageType[],
): [ExtendedChannel[], ExtendedMessageType[]] => {
  // Find matching message types + channels
  const matchingMessageTypes = messageTypes.filter(byPolicy(policies));

  // Aggregate matching channels and channels containing matching message types
  const matchingChannelIds = aggregateChannelIds(matchingMessageTypes);

  return [filterByChannelIds(channels, matchingChannelIds), matchingMessageTypes];
};
